<template>
    <div class="row">
        <div class="col-md-12" v-show="(typeof modal.numero_referencia !='undefined')">
            <b-button v-b-toggle.collapse-1 variant="primary">Ver constancia de registro en el sistema</b-button>
            <b-collapse id="collapse-1" class="mt-2">
                <b-card>
                    <ConstanciaRecepcion :model="modal" />
                </b-card>
            </b-collapse>
        </div>
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-6">
                    <dl class="row mb-0 font-size-14">
                        <dt class="col-sm-4">Nº expediente</dt>
                        <dd class="col-sm-8">: {{modal.numero_referencia}}</dd>

                        <dt class="col-sm-4">Nº folios</dt>
                        <dd class="col-sm-8">: {{modal.folios}}</dd>


                        <dt class="col-sm-4">Fecha registro</dt>
                        <dd class="col-sm-8">: {{formatDate(modal.created_at)}}</dd>

                        <dt class="col-sm-4">Fundamentación</dt>
                        <dd class="col-sm-8">: {{ modal.fundamentacion }}</dd>

                        <dt class="col-sm-4">Archivos adjuntos:</dt>
                        <dd class="col-sm-8">
                            <button class="btn btn-primary"
                                    v-on:click="mostrarValidacion"
                                    v-show="subir_archivos && modal.tipo.permitir_subir_archivos"

                            >Agregar archivos</button>
                            <div v-for="(data,index) in modal.archivos" v-bind:key="index">
                                <a :href="server + '/storage/' + data.nombre" target="_blank">
                                    <i
                                            class="mdi mdi-cloud-download"
                                            style="font-size: 20px;color: #000000"
                                    />
                                    {{data.nombre_original}}
                                </a>


                            </div>

                        </dd>
                    </dl>
                </div>
                <div  class="col-md-6">
                    <dl class="row mb-0 font-size-14">
                        <dt class="col-sm-4">Nombre</dt>
                        <dd class="col-sm-8">: {{modal.denominacion}}</dd>

                        <dt class="col-sm-4">Correo</dt>
                        <dd class="col-sm-8">: {{modal.correo}}</dd>

                        <dt class="col-sm-4">Celular</dt>
                        <dd class="col-sm-8">: {{modal.celular}}</dd>

                        <dt v-if="(modal.documento_identidad_tipo=='01')" class="col-sm-4">DNI</dt>
                        <dt v-if="(modal.documento_identidad_tipo=='06')" class="col-sm-4">RUC</dt>

                        <dd class="col-sm-8">: {{modal.documento_identidad_numero}}</dd>
                    </dl>
                </div>
            </div>



            <div class="row font-size-12">
                <table class="table table-bordered">
                    <thead>
                    <th>Oficina Origen</th>
                    <th>Oficina</th>
                    <th>Fecha</th>
                    <th>Recepcionado</th>
                    <th>Archivos</th>
                    <th>Observacion</th>
                    <th>Derivacion</th>
                    </thead>
                    <tbody>
                    <tr v-for="(data,index) in modal.derivaciones" v-bind:key="index">
                        <td>{{data.oficina_origen}}</td>
                        <td>{{data.oficina}}</td>
                        <td>{{formatDate(data.fecha) }}</td>
                        <td>{{data.recepcionado_str }}</td>
                        <td class="p-0">
                            <div
                                    v-for="(data2, index) in data.archivos"
                                    v-bind:key="index"
                            >
                                <a :href="server + '/storage/' + data2.nombre" target="_blank">
                                    <i
                                            class="mdi mdi-cloud-download"
                                            style="font-size: 20px;color: #000000"
                                    />{{data2.nombre_original}}</a>
                            </div>
                        </td>
                        <td>{{data.observacion}}</td>
                        <td v-if="data.tipo_derivacion!=100 && data.tipo_derivacion!=101 && data.tipo_derivacion!=110">
                          {{data.tipo_derivacion_str }}
                        </td>
                        <td v-if="data.tipo_derivacion==110"> <!--ARCHIVO-->
                          <span class="badge bg-info text-white font-size-14">{{data.tipo_derivacion_str }}</span>
                        </td>
                        <td v-if="data.tipo_derivacion==100"><!--Finalizado-->
                            <span class="badge bg-success text-white font-size-14">{{data.tipo_derivacion_str }}</span>
                        </td>
                        <td v-if="data.tipo_derivacion==101"><!--Rechazado finalizado-->
                            <span class="badge bg-danger text-white font-size-14">{{data.tipo_derivacion_str }}</span>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

        </div>



        <b-modal
                id="modalValidarIndentidad"
                scrollable
                title="Identidad"
                title-class="font-18"
                size="lg"

                hide-footer
        >
            <ValidarIdentidad  :numero_referencia="modal.numero_referencia" v-on:upload-complete="uploadComplete" />
        </b-modal>
    </div>
</template>

<script>
    import ValidarIdentidad from '@/components/validar-identidad-subir-archivo';
    import ConstanciaRecepcion from '@/components/constancia-recepcion'
    export default {
        name: "expediente-info",
        props: {
            modal:{
                type:Object
            },
            subir_archivos:Boolean
        },
        data(){
            return {
                server: process.env.VUE_APP_BACKEND
            }
        },
        components: {
            ValidarIdentidad,ConstanciaRecepcion
        },
        methods :{
            verConstancia(){
                this.$bvModal.show("modalConstanciaRecepcion");
            },
            mostrarValidacion(){
                this.$bvModal.show("modalValidarIndentidad");
            },
            formatDate(value){
                if (value) {
                    return this.$moment(String(value)).format('DD/MM/YYYY HH:mm')
                }
            }
        }
    }

</script>

<style scoped>


</style>
